<template>
  <div class="tooltip-wrapper" @mouseenter="onHover" @mouseleave="hide">
    <slot></slot>
    <div
      v-if="visible"
      class="tooltip-content"
    >
      <!-- Отображение индикатора загрузки или данных -->
      <div v-if="loading" class="loader"></div>
      <div v-else-if="error">Ошибка загрузки данных</div>
      <div v-else>
        <template v-if="data.receipts && data.receipts.length > 0">
          
          <ul>
            <li v-for="(receipt, index) in data.receipts" :key="index">
              <p><strong>Дата поставки:</strong> {{ receipt.moment }}</p>
              <p><strong>Поставщик:</strong> {{ receipt.agent }}</p>
            </li>
          </ul>
        </template>
        <template v-else>
          <p>Нет данных о приемках</p>
        </template>
      </div>
      <div class="tooltip-arrow"></div>
    </div>
  </div>
</template>


<script>import { ORDERS_API_BASE } from '@/config/api';

export default {
  props: {
    content: {
      type: String,
      required: false,
    },
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      error: false,
      data: { receipts: [] },
    };
  },
  methods: {
    async onHover() {
      this.visible = true;
      this.loading = true;
      this.error = false;

      try {
        const response = await fetch(`${ORDERS_API_BASE}/vputi.php?productId=${this.productId}`);
        if (!response.ok) {
          throw new Error("Ошибка загрузки данных");
        }

        const result = await response.json();
        this.data = result; // Сохранение данных
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.error = true;
        console.error("Ошибка загрузки данных:", err);
      }
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>



<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  bottom: 100%; /* Позиция над элементом */
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff; /* Белый фон */
  color: #333; /* Темный текст */
  text-align: left;
  padding: 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Легкая тень */
}

.tooltip-content ul {
  list-style: none; /* Убираем отступы списка */
  padding: 0;
  margin: 0;
}

.tooltip-content li {
  margin-bottom: 8px;
}

.tooltip-content p {
  margin: 0;
  padding: 2px 0;
}

.tooltip-arrow {
  position: absolute;
  top: 100%; /* Расположение уголка под тултипом */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #fff; /* Уголок тултипа */
}

.loader {
  border: 4px solid #f3f3f3; /* Светлый цвет границы */
  border-top: 4px solid #3498db; /* Синий цвет анимации */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



